import { Link } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { ProgressBar } from '@components/progress-bar';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { CardListHeader, CardListItems } from 'components/CardList';
import { IntegrationIcon } from 'components/IntegrationIcon';
import { Loading } from 'components/Loading';

import { NoIntegrations } from './styles';

function IntegrationList({ triggers, loading, url, t, withRatio = false, activeId }) {
  return (
    <CardList>
      <CardListHeader>
        <Text font="bold14">{t('job.integrations.list.title')}</Text>
      </CardListHeader>
      <CardListItems>
        {loading && <Loading style={{ width: 260, padding: 10 }} />}
        {!loading && triggers.length === 0 && (
          <NoIntegrations>{t('job.integrations.list.empty')}</NoIntegrations>
        )}
        {triggers.length > 0 &&
          triggers.map((t) => {
            return (
              <Link
                to={`${url}/integrations/${t.triggerId}`}
                key={t.triggerId}
                style={{ display: 'block' }}
              >
                <Integration active={activeId === t.triggerId}>
                  <Stack space={2} style={{ width: '100%' }}>
                    <Stack space={3} orientation="horizontal">
                      <IntegrationIcon size="1.5rem" integrationName={t.name} color="purple100" />
                      <Text>{t.title}</Text>
                    </Stack>
                    {withRatio && <ProgressBar ratio={t.ratio} />}
                  </Stack>
                </Integration>
              </Link>
            );
          })}
      </CardListItems>
    </CardList>
  );
}

export default observer(IntegrationList);

const Integration = styled.div`
  align-items: center;
  background-color: ${(p) => p.theme.colors.white100};
  border: 0.125rem solid ${(p) => (p.active ? p.theme.blue100 : 'transparent')};
  border-radius: 0.25rem;
  display: flex;
  padding: 1rem;
  width: 100%;
  transition: all 150ms;
  :hover {
    cursor: pointer;
    box-shadow: ${(p) => p.theme.shadows.low};
  }
`;

const CardList = styled.div((p) => ({
  position: 'relative',
  flexShrink: 0,
  ...(p.noHeader && {
    paddingTop: p.theme.spacing.m8,
  }),
  color: p.theme.colors.purple100,
  backgroundColor: p.theme.colors.purpleTrans5,
  borderRadius: '0.25rem',
  borderColor: 'transparent',
  borderWidth: '0.125rem',
  borderStyle: 'dashed',
  height: 'auto',
  maxHeight: '100%',
  display: 'flex',
  flexDirection: 'column',

  ...(p.transparent && {
    backgroundColor: 'transparent',
    borderColor: p.theme.colors.purpleTrans10,
  }),
}));
